import { call, all, put, takeLatest } from "redux-saga/effects";
import { doGet, doPost, doPut } from "../utils/request";
import {
  getAllETOSuccess,
  getAllETOFail,
  addETOSuccess,
  addETOFail,
  getEtoOrTiDetailsSuccess,
  getEtoOrTiDetailsFail,
  getEtoOfDistrictSuccess,
  getEtoOfDistrictFail,
  updateETOSuccess,
  updateETOFail,
} from "../actionCreators/ETO";

function* updateETO({ obj }) {
  try {
    const response = yield doPut(`/usereto/updateEto`, obj);
    yield put(updateETOSuccess(response?.data));
  } catch (err) {
    yield put(updateETOFail(err?.response?.data?.message || err?.message));
    yield put(updateETOFail());
  }
}

function* getEtoOfDistrict({ obj }) {
  try {
    const response = yield doGet(
      `/usereto/getEtosBydistrictId?districtId=${`${obj?.districtId}&search=${obj?.search}`}`
    );
    yield put(getEtoOfDistrictSuccess(response?.data));
  } catch (err) {
    yield put(
      getEtoOfDistrictFail(err?.response?.data?.message || err?.message)
    );
    yield put(getEtoOfDistrictFail());
  }
}

function* getEtoOrTiDetails({ obj }) {
  try {
    const response = yield doGet(
      `/users/getEtoOrTiDetails?userId=${`"${obj?.userId}"`}`
    );
    yield put(getEtoOrTiDetailsSuccess(response?.data));
  } catch (err) {
    yield put(
      getEtoOrTiDetailsFail(err?.response?.data?.message || err?.message)
    );
    yield put(getEtoOrTiDetailsFail());
  }
}

function* getAllETO({ obj }) {
  try {
    const response = yield doGet(
      `/usereto/getAllEtos?page=${obj?.page}&pageSize=${
        obj?.pageSize
      }&userName=${
        [undefined, null, ""].includes(obj?.searchString)
          ? `""`
          : `"${obj?.searchString}"`
      }&filter=${obj?.filterBody}`
    );
    yield put(getAllETOSuccess(response?.data));
  } catch (err) {
    yield put(getAllETOFail(err?.response?.data?.message || err?.message));
    yield put(getAllETOFail());
  }
}

function* addETO({ obj }) {
  try {
    const response = yield doPost(`/usereto/addEto`, obj);
    yield put(addETOSuccess(response?.data));
  } catch (err) {
    // yield put(addETOFail(err?.message));
    yield put(
      addETOFail(
        err?.response?.data?.message
          ? err?.response?.data?.message
          : "Server Down"
      )
    );
  }
}

export default function* watcher() {
  yield all([
    takeLatest("GET_ALL_ETO", getAllETO),
    takeLatest("ADD_ETO", addETO),
    takeLatest("GET_ETO_OR_TI_DETAILS", getEtoOrTiDetails),
    takeLatest("GET_ETO_OF_DISTRICT", getEtoOfDistrict),
    takeLatest("UPDATE_ETO", updateETO),
  ]);
}
